import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import React from "react";
import { DeleteMenuButton } from "~/components/common/parts/button/DeleteMenuButton";
import { ConfirmModal } from "~/components/common/parts/modal/ConfirmModal";
import { TableRow } from "~/components/common/parts/table/TableRow";
import { useImportConversions } from "~/hooks/admin/useImportConversions";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import type { ImportConversion } from "~/models/ImportConversion";
import type { ImportType } from "~/models/ImportLog";
import { isSuccess } from "~/utils/api/api_handler";
import { destroy } from "~/utils/api/ImportConversion";

type Props = {
	importConversion: ImportConversion;
	importType: ImportType;
};

export function ImportConversionTableRow({
	importType,
	importConversion
}: Props) {
	const { notify } = useNotification();
	const { mutate } = useImportConversions().useIndex(importType);
	const { isOpen, handleOpen, handleClose } = useOpenHandler();
	const handleAccept = React.useCallback(async () => {
		const response = await destroy(importConversion.id, importType);
		if (isSuccess(response)) {
			await mutate();
			notify({ content: "削除しました。", variant: "success" });
			handleClose();
			return;
		}
		notify({ content: "削除に失敗しました。", variant: "error" });
	}, [handleClose, importConversion.id, importType, mutate, notify]);
	return (
		<TableRow>
			<td>{importConversion.columnName}</td>
			<td>{importConversion.originalValue}</td>
			<td>{importConversion.convertedValue}</td>
			<td>
				<DeleteMenuButton onClick={handleOpen}>削除</DeleteMenuButton>
				<ConfirmModal
					confirmType="delete"
					handleAccept={handleAccept}
					handleCancel={handleClose}
					isOpen={isOpen}
				>
					削除してよろしいですか？
				</ConfirmModal>
			</td>
		</TableRow>
	);
}
